$(function () {
  $('[data-toggle="popover"]').popover({
    sanitize: false,
    delay: 100
  })
});